/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./v3-game-difficulty.vue?vue&type=template&id=71585f6e&scoped=true&"
import script from "./v3-game-difficulty.vue?vue&type=script&lang=js&"
export * from "./v3-game-difficulty.vue?vue&type=script&lang=js&"
import style0 from "./v3-game-difficulty.vue?vue&type=style&index=0&id=71585f6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71585f6e",
  null
  
)

export default component.exports